import styled from "styled-components";

export const StyledLoadingdiv = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(55, 55, 55, 0.5);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 2000;
  * {
    // width: auto !important;
    height: 30px;
    display: flex;
    color: white;
    justify-content: center;
  }
  & progress {
    height: 13px !important;
  }
`;
export const StyledProgressdiv = styled.progress`
  transform: scaleX(-1);
`;

// .isModal {
//   width: 100%;
//   background-color: transparent;
// }

export const StyledProgressPercentage = styled.span`
  color: #fff !important;
  font-size: 18px !important;
  margin: 0px !important;
  padding: 0px !important;
  direction: ltr !important;
`;
